module.exports = __webpack_public_path__ + "static/girl_phone_rug-7f21f54b6796a225c1bc460ca142586f.png";